import {isFeatureEnabled} from '@github-ui/feature-flags'
import {CodeIcon, ComposeIcon, EyeIcon} from '@primer/octicons-react'
import {SegmentedControl} from '@primer/react'
import {clsx} from 'clsx'

import styles from './segmented-control.module.css'
import type {ViewSwitchProps} from './types'

export const SegmentedControlViewSwitch = ({selectedView, onViewSelect, onLoadPreview, disabled}: ViewSwitchProps) => {
  const hybridEnabled = isFeatureEnabled('markdown_experience_hybrid_editor')

  return (
    <nav>
      <SegmentedControl aria-label="View mode">
        <SegmentedControl.IconButton
          className={clsx(styles.segmentedControl, selectedView === 'edit' && styles.active)}
          selected={selectedView === 'edit'}
          value="edit"
          aria-label="Edit mode"
          disabled={disabled}
          icon={<CodeIcon />}
          onClick={() => onViewSelect?.('edit')}
        />
        <SegmentedControl.IconButton
          className={clsx(styles.segmentedControl, selectedView === 'preview' && styles.active)}
          selected={selectedView === 'preview'}
          value="preview"
          aria-label="Preview mode"
          disabled={disabled}
          icon={<EyeIcon />}
          onClick={() => onViewSelect?.('preview')}
          onMouseOver={() => onLoadPreview?.()}
          onFocus={() => onLoadPreview?.()}
        />
        {hybridEnabled && (
          <SegmentedControl.IconButton
            className={clsx(styles.segmentedControl, selectedView === 'hybrid' && styles.active)}
            value="hybrid"
            selected={selectedView === 'hybrid'}
            aria-label="Hybrid mode"
            disabled={disabled}
            icon={<ComposeIcon />}
            onClick={() => onViewSelect?.('hybrid')}
          />
        )}
      </SegmentedControl>
    </nav>
  )
}

try{ SegmentedControlViewSwitch.displayName ||= 'SegmentedControlViewSwitch' } catch {}